export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6917.e323883f.jpg";